import { QuestionDto } from './questionTypes';
import { Positioned } from './positionedTypes';

export interface BaseCluster {
  id: number,
  title?: string,
  description?: string,
}

export interface QuestionClusterDto extends BaseCluster {
  questions: QuestionDto[],
  position: number
}

export interface QuestionClusterRequest {
  title?: string,
  description?: string,
  questions: QuestionDto[],
}

export interface PositionedQuestionClusterRequest extends Positioned {
  questionCluster: QuestionClusterDto
}

export function emptyQuestionClusterRequest(): QuestionClusterRequest {
  return {
    title: '',
    description: '',
    questions: []
  }
}
